import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/node_modules/@mui/material/esm/Container/Container.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/components/ImpersonationBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/components/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/opt/render/project/src/src/components/SessionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/src/components/ThemeRegistry.tsx");
